import React from "react";
import styled from "../style.module.css";
import { COPPER } from "./theme";

// Ranked share-of-total list with an inline progress bar (reference "Top Performing
// Titles" style). Each row: rank · label (+ optional caption) · share% bar · value.
// valueTooltip/captionTooltip: optional one-line hover explanations for the
// bold value and the caption, shown via a small "i" icon next to each. Useful
// wherever a row shows two different percentages that could otherwise be
// mistaken for the same kind of number (e.g. Top Performing Content: the bold
// value is this title's share of plays among the titles shown, the caption is
// its own unrelated completion rate).
const RankedList = ({ title, rows, emptyHint, accent = COPPER, asOf = true, valueTooltip = null, captionTooltip = null }) => {
  const data = (rows || []).filter((r) => Number(r.value) > 0);
  const total = data.reduce((s, r) => s + Number(r.value), 0);

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {data.length > 0 ? (
        <div className={styled.rankedRows} style={{ maxHeight: 340, overflowY: "auto" }}>
          {data.map((r, i) => {
            const share = total > 0 ? (Number(r.value) / total) * 100 : 0;
            return (
              <div key={i} className={styled.rankedRow}>
                <span className={styled.rankedRank}>{i + 1}</span>
                <div className={styled.rankedMain}>
                  <div className={styled.rankedTop}>
                    <span className={styled.rankedLabel}>{r.label}</span>
                    <span className={styled.rankedValue}>
                      {share.toFixed(1)}%
                      {valueTooltip && (
                        <span className={styled.rankedInfo} tabIndex={0}>
                          i
                          <span className={styled.rankedInfoTooltip}>{valueTooltip}</span>
                        </span>
                      )}
                    </span>
                  </div>
                  <div className={styled.rankedBarTrack}>
                    <div
                      className={styled.rankedBarFill}
                      style={{ width: `${share}%`, background: accent }}
                    />
                  </div>
                  {r.caption != null && (
                    <div style={{ display: "flex", alignItems: "center", marginTop: 5 }}>
                      <span className={styled.rankedCaption} style={{ margin: 0 }}>
                        {r.caption}
                      </span>
                      {captionTooltip && (
                        <span className={styled.rankedInfo} tabIndex={0}>
                          i
                          <span className={styled.rankedInfoTooltip}>{captionTooltip}</span>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default RankedList;
